import type { SVGProps } from 'react'

type IconProps = Omit<SVGProps<SVGSVGElement>, 'viewBox' | 'fill'>

// Decorative glyphs: the control they sit in carries the accessible name.
// Sized and coloured by the CSS of the control that holds them.

const Icon24 = (props: IconProps) => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true' {...props} />
)

const Icon16 = (props: IconProps) => (
  <svg viewBox='0 0 16 16' fill='none' aria-hidden='true' {...props} />
)

const stroke = (width: number) =>
  ({
    stroke: 'currentColor',
    strokeWidth: width,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  }) as const

export const ChevronRightIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='m9 6 6 6-6 6' {...stroke(1.75)} />
  </Icon24>
)

export const ArrowRightIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='M5 12h14m-6-6 6 6-6 6' {...stroke(1.75)} />
  </Icon24>
)

export const CloseIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path d='M7 7l10 10M17 7 7 17' {...stroke(1.75)} />
  </Icon24>
)

export const InfoIcon = (props: IconProps) => (
  <Icon24 {...props}>
    <path
      d='M9.5 10.25H12.25V17.5M9 17.5h6.5'
      stroke='currentColor'
      strokeWidth='1.75'
    />
    <circle cx='12' cy='6.75' r='1.35' fill='currentColor' />
  </Icon24>
)

export const ChevronsUpDownIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path d='m5 6.5 3-3 3 3M5 9.5l3 3 3-3' {...stroke(1.5)} />
  </Icon16>
)

export const CheckIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path d='m3.5 8.5 3 3 6-7' {...stroke(1.5)} />
  </Icon16>
)

export const CloseSmallIcon = (props: IconProps) => (
  <Icon16 {...props}>
    <path d='m4 4 8 8M12 4l-8 8' {...stroke(1.5)} />
  </Icon16>
)

export const ClearCircleIcon = (props: IconProps) => (
  <svg viewBox='0 0 16 16' aria-hidden='true' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM5.47 5.47a.75.75 0 0 1 1.06 0L8 6.94l1.47-1.47a.75.75 0 1 1 1.06 1.06L9.06 8l1.47 1.47a.75.75 0 1 1-1.06 1.06L8 9.06l-1.47 1.47a.75.75 0 0 1-1.06-1.06L6.94 8 5.47 6.53a.75.75 0 0 1 0-1.06Z'
    />
  </svg>
)
